import {
  Box,
  ClickAwayListener,
  Fade,
  IconButton,
  Popper,
  Slider,
  Tooltip,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import TimelinePlayerContext from "../context/TimelinePlayerContext";

export default function PlaybackRateButton() {
  const [anchorEl, setAnchorEl] = useState<Element | undefined>(undefined);
  const { playbackRate, setPlaybackRate } = useContext(TimelinePlayerContext);

  return (
    <>
      <Popper
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        placement="top"
        transition
        sx={{ zIndex: 1, backgroundColor: "inherit" }}
        disablePortal
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Box sx={{ p: "1rem 0" }} onBlur={() => setAnchorEl(undefined)}>
              <Slider
                min={0.25}
                max={2}
                step={0.1}
                onChange={(_, value) => setPlaybackRate(Number(value))}
                onMouseUp={() => setAnchorEl(undefined)}
                value={playbackRate}
                sx={{
                  height: "5rem",
                  '& input[type="range"]': {
                    writingMode: "vertical-lr",
                    direction: "rtl",
                  },
                }}
                orientation="vertical"
              />
            </Box>
          </Fade>
        )}
      </Popper>
      <ClickAwayListener onClickAway={() => setAnchorEl(undefined)}>
        <IconButton
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            setAnchorEl(anchorEl ? undefined : event.currentTarget);
          }}
        >
          <Tooltip title="Player Speed" placement="left">
            <Typography variant="h6" width="1.5rem">
              {playbackRate}x
            </Typography>
          </Tooltip>
        </IconButton>
      </ClickAwayListener>
    </>
  );
}
